var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.06 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.148 9.41v12.072a2.457 2.457 0 0 1-.985 1.842 3.215 3.215 0 0 1-2.06.675H3.957a3.215 3.215 0 0 1-2.06-.675 2.457 2.457 0 0 1-.985-1.842V9.41h18.236zm-1.823 1.824v10.194a.701.701 0 0 1-.238.437c-.273.201-.62.31-.966.31H3.939c-.346 0-.693-.109-.966-.31a.701.701 0 0 1-.238-.437V11.234h14.59zM0 4.851h20.06v1.823H0V4.851zm5.471 0H3.647v-.292c0-1.204.474-2.371 1.332-3.228A4.57 4.57 0 0 1 8.206 0h3.648c1.203 0 2.37.474 3.227 1.331a4.568 4.568 0 0 1 1.332 3.228v.292h-1.824v-.292a2.737 2.737 0 0 0-2.735-2.735H8.206a2.737 2.737 0 0 0-2.735 2.735v.292z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.be0c5f423e5e93561d517985e7e2c1f6.svg";
export { ForwardRef as ReactComponent };